import React, {Component} from 'react';
import {connect} from 'react-redux';
import {undo, redo} from '../state/puzzlesOnBoard';
import {showClearAlert} from "../state/showClearAlert";
import {LanguageContext} from "../App";

class UndoRedo extends Component {
    onKeyDownHandler = e => {
        if ((e.keyCode === 90 && e.shiftKey && (e.ctrlKey || e.metaKey))
            || (e.keyCode === 89 && (e.ctrlKey || e.metaKey))
        ) {
            if (this.props.puzzlesOnBoard.future.length) this.props.redo();
        } else if (e.keyCode === 90 && (e.ctrlKey || e.metaKey)) {
            if (this.props.puzzlesOnBoard.past.length) this.props.undo();
        }
    };

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDownHandler)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDownHandler)
    }

    render() {
        let disabledUn = !this.props.puzzlesOnBoard.past.length;
        let disabledRe = !this.props.puzzlesOnBoard.future.length;

        return (
            <LanguageContext.Consumer>
                {({ language }) =>
                <div id="undoRedo">
                    <button className={disabledUn ? "navi-button inactive" : "navi-button"}
                            onClick={this.props.undo}
                            disabled={disabledUn}>
                        <i className="fas fa-undo-alt left-icon"/>
                        <span className='optionalLabel'>{language['cofnij']}</span>
                    </button>
                    <button className={disabledRe ? "navi-button inactive" : "navi-button"}
                            onClick={this.props.redo}
                            disabled={disabledRe}>
                        <span className='optionalLabel'>{language['przywroc']}</span>
                        <i className="fas fa-redo-alt right-icon"/></button>
                    <button className="navi-button"
                            onClick={() => this.props.showClearAlert("SHOW_CLEAR_ALERT")}>{language['wyczysc']}
                    </button>
                </div>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default connect(
    state => ({
        puzzlesOnBoard: state.puzzlesOnBoard,
    }),
    {undo, redo, showClearAlert}
)(UndoRedo);



// WEBPACK FOOTER //
// ./src/WorkingSpace/UndoRedo.js